export default "__VITE_ASSET__C_SUH4km__"